export const CARET_SIZE = 24;
